module.exports = __webpack_public_path__ + "static/gas-907e9112f6b7ee4d256193fe429b284a.jpg";